import { AxiosResponse } from "axios";
import BaseDAO from "../BaseDAO";
import LogUtil, { LogRequestTipo } from "../../util/LogUtil";

class WPBaseDAO extends BaseDAO {
  protected basePath: string = "https://obahortifruti.com.br/wp-content/themes/phlox";

  protected getBasePath(): string {
    return this.basePath;
  }

  private config: any = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  public get(key:string, url: string): Promise<AxiosResponse<any>> {
    LogUtil.logRequest(LogRequestTipo.GET, key, url, null);
    return super.get(key, url, this.config);
  }
}

export default WPBaseDAO;